import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getRacingConfigs() {
    return {
        palette: {
            [PALETTE_IDS.RACE_CARD]: {
                RACE_CARD_RUNNERS_TABLE: {
                    TABLE_HEADER_SORT_BUTTON_TEXT: {
                        color: COLOR.BRAND.ACCENT3,
                        fontWeight: FONT.WEIGHT_NORMAL,
                    },
                    TABLE_HEADER_MOBILE_SORT_BUTTON_TEXT: {
                        color: COLOR.BRAND.ACCENT3,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    },
                },
                RACE_CARD_INFO_RACE_NUMBER_TEXT: COLOR.BRAND.FOREGROUND5,
                RACE_CARD_MARKETS_BUTTON: {
                    TOGGLE_BUTTON_SELECTED_BG: COLOR.BRAND.ACCENT3,
                },
                RACE_CARD_BEST_ODDS_GUARANTEED_INDICATOR: {
                    BEST_ODDS_GUARANTEED_POPOVER_BG: COLOR.BRAND.BACKGROUND4,
                },
            },
            [PALETTE_IDS.RACE_MEETINGS]: {
                RACE_MEETING_BEST_ODDS_GUARANTEED_INDICATOR: {
                    BEST_ODDS_GUARANTEED_POPOVER_BG: COLOR.BRAND.BACKGROUND4,
                },
                RACE_MEETINGS_LIVE_RACE_ICON_COLOR: COLOR.BRAND.CTA2,
            },
        },
    };
}
